import React from 'react'
import '../../../assets/css/CustomStyle.css'
import Features from './Features'
import Support from './Support'
import Whatour from './Whatour'
import Integration from './Integration'
import EmailSection from './EmailSection'
import HomeBanner from './Homebanner'
import Testimonials from './Testimonials'
import Lorem from './Lorem'

export default function HomeSection() {
  return (
    <div>
        <HomeBanner 
          title='Effortlessly Manage Your Inbox with Toromail - Your AI Email and Comment Assistant' 
          subtitle='Toromail utilizes GPT-4 technology to analyze your writing style and generate responses that mimic your own writing style.'
          OrangeBtn='true'
          GrayBtn='true'
          />
        <EmailSection/>
        <Features/>
        <Support/>
        <Whatour/>
        <Integration/>
        <Testimonials/>
        <Lorem/>
    </div>
  )
}
